/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ParcelOwnershipJuristicTypeEntity { 
    concerned?: boolean;
    id?: number;
    juristicType: number;
    juristicTypeNepropachtovatelne?: boolean;
    juristicTypeNeurceno?: boolean;
    juristicTypePropachtovatel?: boolean;
    juristicTypeVReseni?: boolean;
    juristicTypeVlastniUzivani?: boolean;
    katuzeKod: number;
    lv: number;
    opsubId: number;
    parId: number;
    share?: string;
    shareDenominator?: number;
    shareNumerator?: number;
    subjectName?: string;
}

